import script from "./NotFoundPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotFoundPage.vue?vue&type=script&setup=true&lang=ts"

import "./NotFoundPage.vue?vue&type=style&index=0&id=1aee071f&lang=css"

const __exports__ = script;

export default __exports__